import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, type BusinessInformation } from './types/businessInformation';
import { GeneralPayload } from './types/payloads';

export const RESTAURANT_AND_CAFE_CONTENT_PATH = 'licenses.steps.businessInformation.forms.restaurantAndCafe';

export const restaurantAndCafeSchema = BasicBusinessInformationSchema.extend({
  // Date user will start using music
  startDate: z
    .string()
    .min(1, {
      message: `${RESTAURANT_AND_CAFE_CONTENT_PATH}.startDate.validation.required`,
    })
    // Basic ISO date format check (YYYY-MM-DD)
    .regex(/^\d{4}-\d{2}-\d{2}$/, {
      message: `${RESTAURANT_AND_CAFE_CONTENT_PATH}.startDate.validation.validFormat`,
    }),
  // Area in square meters (must be a number and minimum 1 m²)
  area: z
    .number({
      required_error: `${RESTAURANT_AND_CAFE_CONTENT_PATH}.venueSize.validation.required`,
    })
    .int({ message: `${RESTAURANT_AND_CAFE_CONTENT_PATH}.venueSize.validation.required` })
    .min(1, { message: `${RESTAURANT_AND_CAFE_CONTENT_PATH}.venueSize.validation.required` }),
  hasLiveMusic: z.boolean(),
});

export type RestaurantAndCafeForm = z.infer<typeof restaurantAndCafeSchema>;

export const createRestaurantAndCafeDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.RestaurantAndCafe,
  startDate: '',
  hasLiveMusic: false,
});

export const toPayloadRestaurantAndCafe = (form: RestaurantAndCafeForm, wareNumber: number): GeneralPayload => {
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs(form.startDate).format('YYYY-MM-DD'),
    quantity: form.area ?? 0,
  };
};
